import { AfterViewInit, Component, ElementRef, model, viewChild } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { ICellEditorAngularComp } from 'ag-grid-angular'
import type { ICellEditorParams } from 'ag-grid-community'

@Component({
  selector: 'div[app-text-cell-editor]',
  imports: [
    FormsModule,
  ],
  styles: `
    :host {
      width: 100%;
      height: 100%;
      
      input {
        box-sizing: border-box;
        width: 100%;
        height: 100%;
        font-size: 14px;
      }
    }
  `,
  template: `
    <input
        #input
        class='form-control'
        [(ngModel)]="model"
    >
  `,
})
export class TextCellEditorComponent implements ICellEditorAngularComp, AfterViewInit {
  public readonly model = model<string>('')

  private inputRef = viewChild<ElementRef<HTMLInputElement>>('input')

  ngAfterViewInit() {
    setTimeout(() => {
      const element = this.inputRef()?.nativeElement
      if (element) {
        element.focus()
        element.select()
      }
    }, 0)
  }

  agInit({ value }: ICellEditorParams<unknown, string>) {
    this.model.set(value ?? '')
  }

  getValue(): string | undefined {
    return this.model().trim() || undefined
  }
}